import React, { useEffect, useState, useRef } from "react";
import { GoogleMap, DrawingManager, Polygon } from "@react-google-maps/api";
import { useGoogleMaps } from "../components/GoogleMapsProvider.jsx";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const Map = ({ selectedLatLng, onPolygonCompleted, resetTrigger, polygon }) => {
  const { isLoaded } = useGoogleMaps();
  const polygonRef = useRef(null);

  // Reset the map when `resetTrigger` changes
  useEffect(() => {
    if (polygonRef.current) {
      polygonRef.current.setMap(null); // Remove existing polygon from the map
      polygonRef.current = null; // Reset polygon reference
    }
  }, [resetTrigger]);

  // Handle polygon completion
  const onPolygonComplete = (newPolygon) => {
    if (polygonRef.current) {
      polygonRef.current.setMap(null); // Remove old polygon
    }
    polygonRef.current = newPolygon;
    const polygonPath = newPolygon.getPath().getArray().map((latLng) => ({
      lat: latLng.lat(), // Extract latitude
      lng: latLng.lng(), // Extract longitude
    }));
    onPolygonCompleted(polygonPath); 
  };

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={selectedLatLng}
      zoom={20}
    >
       <Polygon
        paths={polygon}
        options={{
          fillColor: "blue",
          fillOpacity: 0.4,
          strokeColor: "blue",
          strokeOpacity: 0.8,
          strokeWeight: 2,
        }}
      />
      <DrawingManager
        onPolygonComplete={onPolygonComplete}
        options={{
          drawingControl: true,
          drawingControlOptions: {
            drawingModes: ["polygon"],
          },
          polygonOptions: {
            fillColor: "#2196F3",
            fillOpacity: 0.5,
          },
        }}
      />
    </GoogleMap>
  ) : null;
};

export default Map;



